import urlApi from "./urlApi";
export var ADD_STEP_PREFIX_REQUEST = 'ADD_STEP_PREFIX_REQUEST';
export var ADD_STEP_PREFIX_SUCCESS = 'ADD_STEP_PREFIX_SUCCESS';
export var ADD_STEP_PREFIX_ERROR = 'ADD_STEP_PREFIX_ERROR';
export function addStepPrefix(clickedEl, userId) {
    return function (dispatch) {
        dispatch({
            type: ADD_STEP_PREFIX_REQUEST,
        });
        urlApi().addStepPrefix(clickedEl, userId).then(function (res) {
            dispatch({
                type: ADD_STEP_PREFIX_SUCCESS,
                payload: res,
            });
        }).catch(function () {
            dispatch({
                type: ADD_STEP_PREFIX_ERROR,
            });
        });
    };
}
//# sourceMappingURL=addStepPrefix.js.mapimport urlApi from "./urlApi";
export var ADD_STEP_PREFIX_REQUEST = 'ADD_STEP_PREFIX_REQUEST';
export var ADD_STEP_PREFIX_SUCCESS = 'ADD_STEP_PREFIX_SUCCESS';
export var ADD_STEP_PREFIX_ERROR = 'ADD_STEP_PREFIX_ERROR';
export function addStepPrefix(clickedEl, userId) {
    return function (dispatch) {
        dispatch({
            type: ADD_STEP_PREFIX_REQUEST,
        });
        urlApi().addStepPrefix(clickedEl, userId).then(function (res) {
            dispatch({
                type: ADD_STEP_PREFIX_SUCCESS,
                payload: res,
            });
        }).catch(function () {
            dispatch({
                type: ADD_STEP_PREFIX_ERROR,
            });
        });
    };
}
//# sourceMappingURL=addStepPrefix.js.map